module.exports = __webpack_public_path__ + "static/media/weTrust_white.ac0bae84.png";